import { Box, Typography } from "@mui/material";

export default function CircularGauge({ score, size = 44, strokeWidth = 3, showLabel = false, label = "" }) {
  if (score == null) return null;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (Math.min(Math.max(score, 0), 100) / 100) * circumference;

  let color = "#ef4444"; // rose red
  let bgColor = "rgba(239, 68, 68, 0.06)";
  if (score >= 80) {
    color = "#10b981"; // emerald green
    bgColor = "rgba(16, 185, 129, 0.06)";
  } else if (score >= 60) {
    color = "#f59e0b"; // amber yellow
    bgColor = "rgba(245, 158, 11, 0.06)";
  }

  return (
    <Box sx={{ display: "inline-flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
      <Box sx={{ position: "relative", display: "inline-flex", width: size, height: size }}>
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
          {/* Background track */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke="#f3f4f6"
            strokeWidth={strokeWidth}
            fill="transparent"
          />
          {/* Progress track */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke={color}
            strokeWidth={strokeWidth}
            fill="transparent"
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            strokeLinecap="round"
            transform={`rotate(-90 ${size / 2} ${size / 2})`}
            style={{ transition: "stroke-dashoffset 0.5s ease-in-out" }}
          />
        </svg>
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
            bgcolor: bgColor,
            m: `${strokeWidth}px`,
          }}
        >
          <Typography
            sx={{
              fontFamily: '"Cal Sans", "Inter", sans-serif',
              fontSize: size > 60 ? 18 : 13,
              fontWeight: 700,
              color: "#111827",
              lineHeight: 1,
            }}
          >
            {score}
          </Typography>
        </Box>
      </Box>
      {showLabel && label && (
        <Typography
          sx={{
            fontSize: 11,
            fontWeight: 600,
            color: "#6b7280",
            textTransform: "uppercase",
            letterSpacing: "0.05em",
          }}
        >
          {label}
        </Typography>
      )}
    </Box>
  );
}
